<template>
  <div class="login">
    <div class="login-weaper">
      <!-- <div class="login-left">
        <div class="login-time">{{ time.txt }}</div>
        <div class="login-left-box">
          <div>
            <div class="logo">{{ getThemeConfig.globalViceTitle }}</div>
            <h2 class="title">{{ getThemeConfig.globalViceDes }}</h2>
            <div class="msg">
              <div class="msg-author">
                <span>{{ quotations.name }}</span>
                <span>{{ quotations.comeFrom }}</span>
              </div>
              <div class="msg-txt">{{ quotations.content }}</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="login-right">
        <div class="login-main">
          <h4 class="login-title">{{ getThemeConfig.globalTitle }}</h4>
          <el-form class="el-form login-form" :model="ruleForm">
            <el-form-item style="margin-left: 0px" prop="userName">
              <el-input type="text" placeholder="请输入账号" prefix-icon="el-icon-user" v-model="ruleForm.username" clearable
                        autocomplete="off">
              </el-input>
            </el-form-item>
            <el-form-item style="margin-left: 0px" prop="password">
              <el-input
                  type="password"
                  placeholder="请输入密码"
                  prefix-icon="el-icon-lock"
                  v-model="ruleForm.password"
                  autocomplete="off"
                  :show-password="true"
              >
              </el-input>
            </el-form-item>
            <el-form-item style="margin: 40px 0px 0">
              <el-button type="primary" class="login-submit" @click="showCaptcha" :loading="submit.loading">
                <span>{{ $t('message.login.btnText') }}</span>
              </el-button>
            </el-form-item>
          </el-form>
          <!-- <div class="login-menu">
            <a href="javascript:;">{{ $t('message.login.link.one1') }}</a>
            <a href="javascript:;">{{ $t('message.login.link.one2') }}</a>
          </div> -->
        </div>
      </div>
    </div>
    <div class="vue-particles">
      <vue-particles color="#dedede" shapeType="star" linesColor="#dedede" hoverMode="grab" clickMode="push"
                     style="height: 100%"></vue-particles>
    </div>
  </div>
</template>
<script>
import {Session} from '@/utils/storage';
import {formatDate, formatAxis} from '@/utils/formatTime';
import {PrevLoading} from '@/utils/loading.js';
import {quotationsList} from './mock';
import {useLoginApi} from '@/api/login/index';
import { processErrors } from "@/utils/errorHandler";

export default {
  name: 'login',
  data() {
    return {
      quotationsList,
      quotations: {},
      isView: false,
      submit: {
        loading: false,
      },
      ruleForm: {
        username: '',
        password: '',
      },
      time: {
        txt: '',
        fun: null,
      },
      routeObj: {
        pageNo: 1,
        pageSize: 999,
      },
      CaptchaAppId: '',
    };
  },
  beforeCreate(){
    let offline = this.$route.query.offline
    if(offline==1){//如何是掉线,则刷新当前页面并清除url中的参数,重新加载整个页面
      // 获取当前页面的基础 URL
      const baseUrl = window.location.origin + window.location.pathname;
      // 刷新页面并清除参数
      window.location.href = baseUrl;
    }
  },
  computed: {
    // 获取当前时间
    currentTime() {
      return formatAxis(new Date());
    },
    // 获取布局配置信息
    getThemeConfig() {
      return this.$store.state.themeConfig.themeConfig;
    },
  },
  created() {
    this.setUrl();
    this.initTime();
  },
  mounted() {
    this.initRandomQuotations();
    // const script = document.createElement('script');
    // script.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
    // document.head.appendChild(script);
    // this.showCaptcha = this.showCaptcha().bind(this);
  },
  methods: {

    setUrl(){
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      // 检查是否包含 token 参数
      if (urlParams.has('token')) {

        // 删除 token 参数
        urlParams.delete('token');

        // 构建新的查询字符串
        const newQueryString = urlParams.toString();
        const newUrl = window.location.pathname + (newQueryString ? `?${newQueryString}` : '');

        // 使用 history.replaceState 更新 URL（不刷新页面）
        window.history.replaceState({}, '', newUrl);
      }
    },
    // 随机语录
    initRandomQuotations() {
      this.quotations = this.quotationsList[Math.floor(Math.random() * this.quotationsList.length)];
    },
    // 初始化左上角时间显示
    initTime() {
      this.time.txt = formatDate(new Date(), 'YYYY-mm-dd HH:MM:SS WWW QQQQ');
      this.time.fun = setInterval(() => {
        this.time.txt = formatDate(new Date(), 'YYYY-mm-dd HH:MM:SS WWW QQQQ');
      }, 1000);
    },
    // 登录按钮点击
    submitForm() {
      const api = useLoginApi();
      api.signIn(this.ruleForm).then((res) => {
        if (res.code == 0) {
          // 存储 token 到浏览器缓存
          Session.set('token', res.data.token);
          // admin 页面权限标识，对应路由 meta.roles
          let adminRoles = ['admin'];
          // admin 按钮权限标识
          let adminAuthBtnList = ['btn.add', 'btn.del', 'btn.edit', 'btn.link'];
          // common 页面权限标识，对应路由 meta.roles
          api.getUserinfo().then((res) => {
            Session.set("nikename", res.data.name)
            Session.set("roleId", res.data.roleId)
          })
          const userInfos = {
            userName: 'admin',
            photo: 'https://img0.baidu.com/it/u=1833472230,3849481738&fm=253&fmt=auto?w=200&h=200',
            time: new Date().getTime(),
            roles: adminRoles,
            authBtnList: adminAuthBtnList,
          };
          // 存储用户信息到浏览器缓存
          Session.set('userInfo', userInfos);
          // 存储用户信息到vuex
          this.$store.dispatch('userInfos/setUserInfos', userInfos);
          PrevLoading.start();
          this.$router.push('/dashboard');
          setTimeout(() => {
            this.$message.success(`${this.currentTime}，${this.$t('message.login.signInText')}`);
          }, 300);
        } else {
          processErrors(res);
        }
      });

      // this.submit.loading = true;
      // setTimeout(() => {
      // 	let defaultRoles = [];
      // 	let defaultAuthBtnList = [];
      // 	// admin 页面权限标识，对应路由 meta.roles
      // 	let adminRoles = ['admin'];
      // 	// admin 按钮权限标识
      // 	let adminAuthBtnList = ['btn.add', 'btn.del', 'btn.edit', 'btn.link'];
      // 	// common 页面权限标识，对应路由 meta.roles
      // 	let testAuthPageList = ['common'];
      // 	// test 按钮权限标识
      // 	let testAuthBtnList = ['btn.add', 'btn.link'];
      // 	if (this.ruleForm.userName === 'admin') {
      // 		defaultRoles = adminRoles;
      // 		defaultAuthBtnList = adminAuthBtnList;
      // 	} else {
      // 		defaultRoles = testAuthPageList;
      // 		defaultAuthBtnList = testAuthBtnList;
      // 	}
      // 	const userInfos = {
      // 		userName: this.ruleForm.userName === 'admin' ? 'admin' : 'test',
      // 		photo:
      // 			this.ruleForm.userName === 'admin'
      // 				? 'https://img0.baidu.com/it/u=1833472230,3849481738&fm=253&fmt=auto?w=200&h=200'
      // 				: 'https://img2.baidu.com/it/u=2187913762,2708298335&fm=253&fmt=auto&app=138&f=JPEG?w=200&h=200',
      // 		time: new Date().getTime(),
      // 		roles: defaultRoles,
      // 		authBtnList: defaultAuthBtnList,
      // 	};
      // 	// 存储 token 到浏览器缓存
      // 	Session.set('token', Math.random().toString(36).substr(0));
      // 	// 存储用户信息到浏览器缓存
      // 	Session.set('userInfo', userInfos);
      // 	// 存储用户信息到vuex

      // 	PrevLoading.start();

      // 	setTimeout(() => {
      // 		this.$message.success(`${this.currentTime}，${this.$t('message.login.signInText')}`);
      // 	}, 300);
      // }, 300);
    },

    /**
     * 显示验证码
     */
    showCaptcha() {
      if (this.ruleForm.password == '' || this.ruleForm.userName == '') {
        this.$message({
          message: '账号或者密码为空',
          type: 'warning',
        });
      } else {
        this.submitForm()
        // const api = useLoginApi();
        // api.getCaptchaAppId().then((res) => {
        //   if (res.code == 0) {
        //     this.CaptchaAppId = res.data;
        //     try {
        //       // 生成一个验证码对象
        //       // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
        //       //callback：定义的回调函数
        //       let captcha = new TencentCaptcha(this.CaptchaAppId, this.callback, {});
        //       // 调用方法，显示验证码
        //       captcha.show();
        //     } catch (error) {
        //       // 加载异常，调用验证码js加载错误处理函数
        //       this.loadErrorCallback();
        //     }
        //   } else {
        //     processErrors(res);
        //   }
        // });
      }
    },

    loadErrorCallback() {
      let appid = this.CaptchaAppId;
      // 生成容灾票据或自行做其它处理
      let ticket = 'terror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
      this.callback({
        ret: 0,
        randstr: '@' + Math.random().toString(36).substr(2),
        ticket: ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error'
      });
    },

    // 定义回调函数
    callback(res) {
      // 第一个参数传入回调结果，结果如下：
      // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
      // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
      // CaptchaAppId       String    验证码应用ID。
      // bizState    Any       自定义透传参数。
      // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。

      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
      // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
      if (res.ret === 0) {
        let params = {
          ticket: res.ticket,
          randstr: res.randstr,
        };
        const api = useLoginApi();
        api.getCaptcha(params).then((res) => {
          if (res.code == 0) {
            this.submitForm();
          } else {
            processErrors(res);
          }
        });
      }
    },

  },

  destroyed() {
    clearInterval(this.time.fun);
  },
};
</script>

<style scoped lang="scss">
.login {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  position: relative;

  .vue-particles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(ellipse at top left, rgba(105, 155, 200, 1) 0%, rgba(181, 197, 216, 1) 57%);
  }

  .login-weaper {
    margin: auto;
    height: 500px;
    display: flex;
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    border: none;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

    .login-left {
      width: 491px;
      padding: 20px;
      font-size: 16px;
      color: var(--prev-color-text-white);
      position: relative;
      background-color: var(--prev-color-primary);
      display: flex;
      flex-direction: column;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;

      .login-time {
        width: 100%;
        color: var(--prev-color-text-white);
        opacity: 0.9;
        font-size: 14px;
        overflow: hidden;
      }

      .login-left-box {
        flex: 1;
        overflow: hidden;
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        padding: 80px 45px;

        .logo {
          font-size: 22px;
          margin-bottom: 15px;
        }

        .title {
          color: var(--prev-color-text-white);
          font-weight: 300;
          letter-spacing: 2px;
          font-size: 16px;
        }

        .msg {
          color: var(--prev-color-text-white);
          font-size: 13px;
          margin-top: 35px;

          .msg-author {
            opacity: 0.6;

            span:last-of-type {
              margin-left: 15px;
            }
          }

          .msg-txt {
            margin-top: 15px;
            line-height: 22px;
          }
        }
      }
    }

    .login-right {
      width: 491px;
      padding: 20px;
      position: relative;
      align-items: center;
      display: flex;
      background-color: var(--prev-bg-white);
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;

      .login-main {
        margin: 0 auto;
        width: 70%;

        .login-title {
          color: var(--prev-color-text-primary);
          margin-bottom: 40px;
          font-weight: 500;
          font-size: 22px;
          text-align: center;
          letter-spacing: 4px;
        }

        .login-form {
          margin: 10px 0;

          i {
            color: var(--prev-color-text-primary);
          }

          .el-form-item {
            margin-bottom: 20px !important;

            .login-code {
              display: flex;
              align-items: center;
              justify-content: space-around;
              margin: 0 0 0 10px;
              user-select: none;

              .login-code-img {
                margin-top: 2px;
                width: 100px;
                height: 38px;
                border: 1px solid var(--prev-border-color-base);
                color: var(--prev-color-text-primary);
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 5px;
                line-height: 38px;
                text-indent: 5px;
                text-align: center;
                cursor: pointer;
                transition: all ease 0.2s;
                border-radius: 4px;

                &:hover {
                  border-color: var(--prev-border-color-hover);
                  transition: all ease 0.2s;
                }
              }
            }

            .login-submit {
              width: 100%;
              letter-spacing: 2px;
            }
          }
        }

        .login-menu {
          margin-top: 30px;
          width: 100%;
          text-align: left;

          a {
            color: var(--prev-color-text-secondary);
            font-size: 12px;
            margin: 0 8px;
            text-decoration: none;

            &:hover {
              color: var(--prev-color-primary);
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
</style>
